<template>
  <div>
    <van-notice-bar wrapable :scrollable="false" text="系统将按实际加注量自动扣款，加注升数将限制最大加注量，启动加注后请在60s内提枪加注"/>
    <div style="margin: 1vw;">
    </div>
    <van-form @submit="onSubmit">
      <van-field label="" value="自助加注机" readonly/>
      <van-field v-model="device_imei" label="设备号" readonly/>
      <van-field v-model="mobile" label="手机号" readonly/>
      <van-field v-model="truckNo" label="车牌" readonly/>
      <van-field v-model="available_num" label="最大可加升数" readonly/>
      <van-field label="加注升数" placeholder="请输入加注升数" readonly clickable :value="value"
                 @touchstart.native.stop="show = true"/>
      <van-number-keyboard theme="custom" extra-key="." close-button-text="完成" v-model="value" :show="show"
                           :maxlength="3" @blur="show = false"/>
      <div style="margin: 10vw;">
        <van-button round block size="large" type="info" native-type="submit">启动加注机</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Form, NoticeBar, NumberKeyboard} from 'vant';
import common from "../../common";
import querystring from "querystring";

Vue.use(Form);
Vue.use(NoticeBar);
Vue.use(NumberKeyboard);

export default {
  name: "qrcode",
  data() {
    return {
      device_imei: "",
      qrcode: '',
      show: true,
      value: '',
      token: "",
      mobile: "",
      data: "",
      pre_price: "",
      pre_num: "",
      truckNo: "",
      userId: "",
      userName: "",
      service: "",
      requestId: "",
      number: "",
      car_arr: [],
      available_num: "",
      order_id: "",
    }
  },
  methods: {
    onClickLeft() {

    },
    onSubmit(values) {
      let querystring = require("querystring");
      this.$api.post("wx/device/order",
          querystring.stringify({
            value: this.value,
            device_imei: this.device_imei,
            mobile: this.mobile,
            truckNo: this.truckNo,
            available_num: this.available_num,
            order_id: this.order_id,
          })
      ).then(({data}) => {
        if (data.code == 1000) {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
            this.$router.push({ path: '/device/orderResult/'+this.order_id});
          });
        }
        if(data.status==0){
          Dialog.alert({
            message: data.msg,
          })
        }
      });
    },
    //获取可加油量以及油站信息
    getNumStation() {
      let querystring = require('querystring');
      this.$api.post('/wx/getDevice',
          querystring.stringify({
            token: this.token,
            car_number: this.truckNo,
            imei: this.device_imei
          })
      ).then(data => {
        if (data.data.status == 1) {
          this.data = data.data.data;
          this.available_num = data.data.data.surplus;
          this.order_id = data.data.data.order_id;
        } else {
          this.available_num = 0;
          common.toast(data.data.msg);
        }
      }).catch((err) => {

      })
    },
    getData() {
      //获取司机车牌号(可能有多个)
      let querystring = require('querystring');
      this.$api.post("wx/index",
          querystring.stringify({
            token: this.token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let car_Obj = data.data.data.car_list;
          //获取司机车牌号
          if (data.data.data.car_number) {
            this.truckNo = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
          for (var index in car_Obj) {
            this.car_arr.push(car_Obj[index]);
          }
          this.getNumStation();
        } else {
          this.$router.replace({name: 'login'});
        }
      })
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require('querystring');
      this.$api.post('/wx/getUrl',
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      })
    },
    checkStatus() {
      let querystring = require('querystring');
      this.$api.post('/wx/device/status',
          querystring.stringify({
            imei: this.device_imei
          })
      ).then(({data}) => {
        if (data.code !== "1000") {
          Dialog.alert({
            title: '错误',
            message: data.msg,
          }).then(() => {
            // on close
          });
        }
      })
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require("querystring");
      this.$api
          .post("/wx/checkOpenid",
              querystring.stringify({
                openid
              })
          )
          .then(({data}) => {
            if (data.status == 1) {
              //绑定了手机号,获取用户信息
              common.setCookie("token", data.data.token, 365);
              common.setCookie("mobile", data.data.mobile, 365);
              this.login_bol = true;
              this.mobile = data.data.mobile;
              this.getData(data.data.token);
            } else {
              //没有绑定了手机号,去登录页绑定
              this.$router.push({
                name: "login",
                query: {
                  openid: openid
                }
              });
            }
          });
    },
  },
  mounted() {
    this.device_imei = this.$router.currentRoute.params.imei;
    this.value = this.$route.query.pre_num;
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getData();
    } else if (ifcookietoken) {
      this.mobile = common.getCookie("mobile");
      this.token = common.getCookie("token");
      this.getData();
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.getOpenid();
    }
    this.checkStatus();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/device/order.vue